import { adoptStyles, css, } from 'lit';
import { getTheme } from './config.js';
import { CHANGE_THEME_EVENT } from './theming-event.js';
class ThemeEventListeners {
    constructor() {
        this.listeners = new Set();
        this.handleEvent = () => {
            for (const listener of this.listeners) {
                listener();
            }
        };
    }
    add(listener) {
        globalThis.addEventListener(CHANGE_THEME_EVENT, this);
        this.listeners.add(listener);
    }
    remove(listener) {
        this.listeners.delete(listener);
        if (this.listeners.size < 1) {
            globalThis.removeEventListener(CHANGE_THEME_EVENT, this);
        }
    }
}
const _themingEventListeners = new ThemeEventListeners();
class ThemingController {
    constructor(host, themes) {
        this.themeChanged = () => {
            this.adoptStyles();
            this.host.requestUpdate();
        };
        this.host = host;
        this.themes = themes;
    }
    hostConnected() {
        this.adoptStyles();
        _themingEventListeners.add(this.themeChanged);
    }
    hostDisconnected() {
        _themingEventListeners.remove(this.themeChanged);
    }
    adoptStyles() {
        const { theme, themeVariant } = getTheme();
        this.theme = theme;
        this.themeVariant = themeVariant;
        const ctor = this.host.constructor;
        const stylesheets = Object.entries(this.themes[themeVariant]);
        const [_unused, sharedStyles] = stylesheets.find(([name]) => name === 'shared') ?? [];
        const [_, themeStyles] = stylesheets.find(([name]) => name === this.theme) ?? [];
        adoptStyles(this.host.shadowRoot, [
            ...ctor.elementStyles,
            sharedStyles ?? css ``,
            themeStyles ?? css ``,
        ]);
    }
}
const _updateWhenThemeChanges = (host, themes, exposeTheme) => {
    const controller = new ThemingController(host, themes);
    host.addController(controller);
    if (exposeTheme) {
        Object.defineProperty(host, themeSymbol, {
            get() {
                return controller.theme;
            },
            configurable: true,
            enumerable: false,
        });
    }
    return controller;
};
export const updateWhenThemeChanges = _updateWhenThemeChanges;
export const themeSymbol = Symbol('Current active theme');
